import { AppLayout } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';
import { FooterCopyrightSection } from './FooterCopyrightSection';

// import { FooterLinkSection } from './FooterLinkSection';

export type IFooterProps = IContainerProps;

const styles = stylex.create({
  host: {
    backgroundColor: colorSchemeTokens.surfaceContainerLow,
    color: colorSchemeTokens.onSurfaceVariant,
  },
  inner: {
    maxWidth: 1248,
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',

    paddingTop: '4rem',
    paddingBottom: '4rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
  },
});

export const Footer: React.FC<IFooterProps> = (props) => {
  const { sx } = props;

  return (
    <AppLayout.Footer sx={sx} divider>
      <div {...stylex.props(styles.inner)} id="crowdaa-footer">
        {/* <FooterLinkSection /> */}
        <FooterCopyrightSection />
      </div>
    </AppLayout.Footer>
  );
};
